import React, { useContext } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { UserContextProvider } from '../context/authContext';
import { ProtectedRoute } from './ProtectedRoute';
import { LoginPage } from './LoginPage';
import { App } from '../App';
import { DocumentContextProvider } from '../context/documentContext';

export const Routing = () => {
  return (
    <UserContextProvider>
      <Router>
        <DocumentContextProvider>
          <Routes>
            <Route element={<App />} path="/app/*" />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/*" element={<LoginPage />} />
          </Routes>
        </DocumentContextProvider>
      </Router>
    </UserContextProvider>
  );
};
